<template>
    <div class="identification">
        <!-- <div class="blank"></div> -->
        <div class="submit-form">
            <van-form @submit="handleSubmit" style="width: 100%;" label-width="5.2em">
                <div class="intro-form-item mr">
                    <strong>*</strong>
                    <van-field v-model="userData.user_name" label="真实姓名" placeholder="请输入真实姓名"/>
                </div>
                <div class="intro-form-item mr">
                    <strong>*</strong>
                    <van-field v-model="userData.id_card" label="身份证号" placeholder="请输入身份证号"/>
                </div>
                <!-- 专业领域 -->
                <div class="submit-form-item">
                    <div class="intro-form-item" style="border:none;">
                        <strong>*</strong>
                        <span class="label-text">所属专业领域（可多选）</span>
                    </div>
                    <div class="et-box">
                        <label v-for="(item,index) in etArr" :key="index">
                            <input type="checkbox" id="" v-model="userData.expert_type" :value="item.et_id">
                            <span class="et-item">{{item.et_name}}</span>
                        </label>
                    </div>
                </div>
                <!-- 职称 -->
                <div class="submit-form-item">
                    <div class="intro-form-item" style="border:none;">
                        <strong>*</strong>
                        <span class="label-text" style="width: 5.2em;">职称</span>
                        <span class="positional-title-name" @click="postPicker = true" v-if="!positional_title">请选择您的职称</span>
                        <span class="positional-title-name" style="color:#333;" @click="postPicker = true" v-else>{{positional_title}}</span>
                        <van-icon name="arrow" size="3.73vw"/>
                    </div>
                    <van-popup v-model="postPicker" position="bottom" closeable round>
                        <div class="select-title-box">
                            <h5 class="title">选择职称</h5>
                            <div class="select-item-wrap">
                                <div class="select-item" v-for="(item,index) in pt_list" :key="index">
                                    <span v-for="(element,i) in item" :key="i" :class="userData.positional_title === element.pt_id ? 'select-item-active' : ''" @click="changePost(element)">{{element.pt_name}}</span>
                                </div>
                            </div>
                        </div>
                    </van-popup>
                </div>
                <!-- 擅长种类 -->
                <div class="submit-form-item">
                    <div class="intro-form-item" style="border:none;">
                        <strong>*</strong>
                        <span class="label-text" style="width: 5.2em;">擅长种类</span>
                    </div>
                    <van-checkbox-group v-model="userData.class_id" direction="horizontal">
                        <van-checkbox style="font-size:3.73vw;margin-bottom:5.33vw;" :name="item.class_id" shape="square" icon-size="4.27vw" v-for="item in animal" :key="item.class_id">{{item.class_name}}</van-checkbox>
                    </van-checkbox-group>
                </div>
                <!-- 资质证明 -->
                <div class="submit-form-item">
                    <div class="intro-form-item" style="border:none;">
                        <strong>*</strong>
                        <span class="label-text">资质证明</span>
                    </div>
                    <van-field name="uploader">
                        <template #input>
                            <van-uploader 
                                v-model="prove_uri" 
                                accept="image/jpeg, image/png, image/jpg, application/msword"
                                :max-size="50 * 1024 * 1024"
                                @oversize="onOversize"
                                :after-read="afterRead"
                                :before-delete="beforeDelete"
                            />
                        </template>
                    </van-field>
                    <div class="tips">
                        请提供专业资质证明<br>
                        如：学位证、毕业证、兽医资格证（任意一种）
                    </div>
                </div>
                <!-- 参加工作年份 -->
                <div class="submit-form-item">
                    <div class="intro-form-item" style="border:none;">
                        <span class="label-text" style="width: 9.2em;padding-left:0;">参加工作年份</span>
                        <van-field readonly name="picker" right-icon="arrow" :value="userData.service_begin_year" placeholder="请选择参加工作年份" @click="timePicker = true" style="padding:10px 0 10px 6px;"/>
                    </div>
                    <van-popup v-model="timePicker" position="bottom" round>
                        <van-picker
                            title="选择年份"
                            show-toolbar
                            :columns="dataColumns"
                            @confirm="onConfirm"
                            @cancel="timePicker = false"
                        />
                    </van-popup>
                </div>
                <div class="intro-form-item mr">
                    <van-field v-model="userData.company_name" label="现任职单位" placeholder="请输入您的现任职单位" class="pl"/>
                </div>
                <div class="intro-form-item mr">
                    <van-field v-model="userData.post" label="职务" placeholder="请输入您的职务" class="pl"/>
                </div>
                <!-- 服务定位 -->
                <div class="submit-form-item">
                    <div class="intro-form-item bet-ween">
                        <span class="label-text pl">服务定位</span>
                        <van-switch v-model="switchChecked" size="20" active-color="#34C759"/>
                    </div>
                    <template v-if="switchChecked">
                        <div class="intro-form-item">
                            <strong>*</strong>
                            <van-field readonly label="所在地区" right-icon="arrow" :value="citys" placeholder="请选择省市区" @click="showArea = true" style="padding:10px 0 10px 6px;"/>
                        </div>
                        <van-popup v-model="showArea" position="bottom">
                        <van-area
                            :area-list="areaList"
                            @confirm="onConfirmArea"
                            @cancel="showArea = false"
                        />
                        </van-popup>
                        <div class="intro-form-item">
                            <strong>*</strong>
                            <van-field v-model="userData.address" label="详细地址" placeholder="请输入详细地址"/>
                        </div>
                    </template>
                    <div class="address-tips">
                        <h6 class="address-tips-title">温馨提示：</h6>
                        <div class="address-tips-text">
                            1、填写详细地址后更快获得养殖户精准咨询。<br> 2、您的地址信息仅用于地图找专家功能使用。<br> 3、您可以通过关闭地图找专家功能，停止对您的位置展示。
                        </div>
                    </div>
                </div>
                <div class="blank"></div>
                <div class="submit-form-item">
                    <div class="intro-form-item bet-ween" style="border:none;">
                        <span class="label-text pl">专业特长/学术成就</span>
                    </div>
                    <van-field
                        style="border: 1px solid #cccccc;border-radius: 4px;"
                        v-model="userData.skills"
                        rows="3"
                        autosize
                        label=""
                        type="textarea"
                        placeholder="请输入您的专业特长/学术成就信息"
                    />
                </div>
                <div class="submit-form-item">
                    <div class="intro-form-item bet-ween" style="border:none;">
                        <span class="label-text pl">教育背景</span>
                    </div>
                    <van-field
                        style="border: 1px solid #cccccc;border-radius: 4px;"
                        v-model="userData.education"
                        rows="3"
                        autosize
                        label=""
                        type="textarea"
                        placeholder="请输入您的专业特长/学术成就信息"
                    />
                </div>
                <div class="submit-form-item pb">
                    <div class="intro-form-item bet-ween" style="border:none;">
                        <span class="label-text pl">工作简介</span>
                    </div>
                    <van-field
                        style="border: 1px solid #cccccc;border-radius: 4px;"
                        v-model="userData.career"
                        rows="3"
                        autosize
                        label=""
                        type="textarea"
                        placeholder="请输入您的专业特长/学术成就信息"
                    />
                </div>
                <div class="tips-checked">
                    <van-checkbox v-model="introChecked"></van-checkbox>
                    <span @click="$router.push('/authentication')"> 《专家用户协议》</span>
                </div>
                <van-notice-bar color="#FF8062" background="rgba(255,128,98,0.15)" left-icon="info-o" class="mb">
                    温馨提示：信息完善都越高，专家排名越靠前。
                </van-notice-bar>
                <div class="submit-btn pb">
                    <van-button round block native-type="submit" :disabled="!introChecked">提交</van-button>
                </div>
            </van-form>
        </div>
    </div>
</template>
<script>
import { getUserType, updateexpertinfo } from '@/api/resetApi.js';
import { Toast } from 'vant';
import OSS from 'ali-oss';
import { areaList } from '@vant/area-data';
export default {
    name:'identification',
    data(){
        return {
            introChecked:true,
            timePicker:false,
            postPicker: false,
            switchChecked:false,
            showArea:false,
            userData:{
              token: localStorage.getItem('eToken'),
              user_id: localStorage.getItem('userId'),
            //   user_id:this.$route.query.user_id,
              user_name:'',
              id_card:'',
              service_begin_year:'',
              post:'',
              group_unit:'',
              expert_type:[],
              positional_title:'',
              skills:'',
              education:'',
              career:'',
              class_id:[],
              company_name:'',
              prove_uri:[],
              address:'',
              province: '',
              city: '',
              county: '',
            },
            areaList,
            citys:'',
            etArr:[],
            pt_list:[],
            animal:[],
            dataColumns:[],
            urls:[],
            prove_uri:[],
            positional_title:''
        }
    },
    watch: {
        switchChecked(val){
            if(!val){
                this.userData.province = ''
                this.userData.city = ''
                this.userData.county = ''
                this.userData.address = ''
                this.citys = ''
            }
        },
        '$route'(val,oldVal){
            if(val.name === 'identification' && oldVal.name !== 'authentication') {
                this.userData = {}
            }
        }
    },
    created () {
        getUserType().then(res=>{
            if(res.data.code === 1){
                this.etArr = res.data.obj.et
                this.pt_list = res.data.obj.pt_list
                this.animal = res.data.obj.animal
            }
        })
        this.getInitYear()
        this.configoss()
    },
    methods: {
        // 初始化年份
        getInitYear() {
            let myYear = [];
            for (let i = 70; i <= new Date().getYear(); i++){
                let now = 1900 + i;
                myYear.push(now)
            }
            this.dataColumns = myYear.reverse()
        },
        //初始化oss
        configoss() {
            this.client = new OSS({
            region: 'oss-cn-beijing', //地区
            accessKeyId:'LTAI01SbNvZ4Balm',
            //accessKeyId: 'LTAIY713pjruaMYc', //申请的osskey
            accessKeySecret: 'SBbyg3HEPSAJRZP4t4GTRR7STA8jGk',
            //accessKeySecret: 'ju2c4XhXWDZrtKypFrInwk8ZSI2dO8', //申请的osssecret
            bucket: 'zkjy', //oss应用名
            dirPath: 'oss/document/manager-cont/cont/', //oss 文件夹 不存在会自动创建
            })
        },
        // 上传图片组件
        onOversize() {
            Toast.fail('请上传大小≤2M的文件');
        },
        afterRead(file) {
            Toast.loading({
                duration: 5, // 持续展示 toast
                forbidClick: true,
                message: '上传中',
            });
            if (file.length) { //判断是否选择了多个文件，如果是的话，循环遍历单个文件上传
                file.forEach((f) => {
                    this.uploadFile(f);
                });
            } else {
                this.uploadFile(file);
            }
        },
        beforeDelete(file,detail){
            this.userData.prove_uri.splice(detail.index,1)
            this.prove_uri.splice(detail.index,1)
        },
        uploadFile(e) {
            let file = e.file;
            let pos = file.name.lastIndexOf('.');
            let imageKey = `${file.name.substring(0, pos)}-${new Date().getTime()}`
            this.client.multipartUpload('/oss/document/manager-cont/images/' + imageKey,file).then(resp => {
                Toast.clear();
                let {res} = resp
                this.urls = res.requestUrls[0]
                if(this.urls.indexOf("?") != -1){
                    this.urls = this.urls.split("?")[0];
                }
                if (this.urls) {
                    this.userData.prove_uri.push(this.urls);
                    Toast.success('上传成功！');
                } else {
                    this.prove_uri.pop()
                    Toast.fail('上传失败');
                }
            }).catch(err => {})
        },
        onConfirm(value){
            this.userData.service_begin_year = value
            this.timePicker = false
        },
        onConfirmArea(value){
            if(value[0].name === value[1].name) {
                value[1].name = '市辖区'
            }
            this.showArea = false
            this.userData.province = value[0].name
            this.userData.city = value[1].name
            this.userData.county = value[2].name
            this.citys = `${value[0].name}/${value[1].name}/${value[2].name}`
        },
        changePost(item){
            this.userData.positional_title = item.pt_id
            this.positional_title = item.pt_name
            this.postPicker = false
        },
        handleSubmit() {
            const re = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
            if(!this.userData.user_name){
                return Toast('真实姓名不能为空')
            }else if(!this.userData.id_card){
                return Toast('身份证号不能为空')
            } else if(!re.test(this.userData.id_card)){
                return Toast('请填写正确的身份证号')
            } else if(this.userData.expert_type.length === 0){
                return Toast('请选择所属专业领域（可多选）')
            }else if(!this.userData.positional_title){
                return Toast('请选择您的职称')
            } else if(this.userData.class_id.length === 0){
                return Toast('请选择您的擅长种类')
            } else if(this.userData.prove_uri.length === 0){
                return Toast('请上传资质证明')
            } else if(this.switchChecked && !this.citys){
                return Toast('请选择省市区')
            } else if(this.switchChecked && !this.userData.address){
                return Toast('请输入详细地址')
            } else {
                let userObj = JSON.parse(JSON.stringify(this.userData))
                userObj.class_id = userObj.class_id.join(",")
                userObj.prove_uri = userObj.prove_uri.join(",")
                userObj.expert_type = userObj.expert_type.join(",")
                userObj.show_in_map = this.switchChecked ? 1 : 0
                this.updateexpertinfo(userObj)
            }
        },
        async updateexpertinfo(data) {
            const formData = new FormData();
            //循环传入的值转换formData
            Object.keys(data).forEach((key) => {
                formData.append(key, data[key]);
            })
            const res = await updateexpertinfo(formData)
            try {
            if (res.data.code == 1) {
                Toast.success('提交成功');
                this.$router.replace('/certification')
            } else {
                Toast.fail(res.data.msg);
            }
            } catch (error) {}
        },
    }
}
</script>
<style scoped lang="scss">
    .identification{
        .pl{
            padding-left: 0 !important;
        }
        .mr{
            margin: 0 5.33vw;
        }
        .pb{
            padding-bottom: 6.4vw;
        }
        .mb{
            margin-bottom: 3.73vw;
        }
        .blank{
            height: 2.67vw;
            background: #f5f5f5;
        }
        .bet-ween{
            justify-content: space-between;
        }
        .intro-form-item{
            display: flex;
            height: 11.2vw;
            align-items: center;
            opacity: 1;
            border-bottom: 0.27vw solid #f5f5f5;
            strong{
                opacity: 1;
                font-size: 0.14rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #f14f4c;
                // line-height: 1.43;
                margin-left: 1.6vw;
            }
            .label-text{
                color: #646566;
                font-size: 14px;
                padding-left:6px;
                text-align: left;
            }
            .positional-title-name{
                flex: 1;
                font-size: 3.73vw;
                font-weight: 400;
                text-align: left;
                color: #969799;
                margin-left: 12px;
            }
            .van-cell{
                line-height: inherit;
                padding-left:6px ;
            }
            .van-field__label{
                margin-right: 0 !important;
            }
            
        }
        .submit-form-item{
            border-bottom: 0.27vw solid #f5f5f5;
            margin: 0 5.33vw;
            .et-box {
                font-size: 0 !important;
                display: flex;
                margin-right: -2.13vw;
                padding-bottom: 2.67vw;
                .et-item{
                    display: inline-block;
                    width: 20.26vw;
                    height: 9.07vw;
                    background: #f5f5f5;
                    border: 0.27vw solid #f5f5f5;
                    border-radius: 1.07vw;
                    font-size: 3.73vw;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #333333;
                    line-height: 9.6vw;
                    margin-right: 2.13vw;
                }
                input[type="checkbox"]{
                    position: absolute;
                    left: -20px;
                }
                input[type="checkbox"]:checked + .et-item {
                    background: #e7f1fc;
                    border-color: #0186ff;
                    color: #0186ff;
                }
            }
            .select-title-box {
                background: white;
                .title{
                    font-size:4.8vw;
                    padding: 5vw 0;
                    color: #181818;
                    background: #f5f5f5;
                }
                .select-item-wrap{
                    background: white;
                    padding: 5.87vw 5.33vw 8vw;
                    .select-item {
                        font-size: 0 !important;
                        display: flex;
                        span{
                            width: 27.73vw;
                            height: 9.07vw;
                            background: #f5f5f5;
                            border: 0.27vw solid #f5f5f5;
                            border-radius: 1.07vw;
                            font-size: 3.73vw;
                            font-family: PingFangSC, PingFangSC-Regular;
                            font-weight: 400;
                            text-align: center;
                            color: #333333;
                            line-height: 9.6vw;
                            margin-right: 2.13vw;
                            margin-bottom: 2.67vw;
                        }
                        .select-item-active{
                            background: #e7f1fc;
                            border-color: #0186ff;
                            color: #0186ff;
                        }
                    }
                }
            }
            .tips{
                font-size: 3.2vw;
                font-weight: 400;
                text-align: left;
                color: #ff716e;
                line-height: 5.33vw;
                padding-bottom: 4.27vw;
            }
            .van-cell::after{
                border: none;
            }
            .address-tips{
                padding: 2.67vw 0;
                .address-tips-text, .address-tips-title{
                    font-size: 3.2vw;
                    font-weight: 400;
                    text-align: left;
                    color: #666666;
                    line-height: 5.33vw;
                }
            }
        }
        .submit-btn {
            button{
                width: 81.6vw;
                height: 11.73vw;
                background: linear-gradient(315deg,#096fcb, #2784f8);
                border-radius: 5.87vw;
                backdrop-filter: blur(2.67vw);
                margin: 0 auto;
                color: #ffffff;
                font-size: 4.8vw;
            }
        }
        .tips-checked{
            font-size: 0 !important;
            display: flex;
            padding: 3vw 5.33vw;
            align-items: center;
            span{
                font-size: 3.73vw;
                font-family: AlibabaPuHuiTiR;
                text-align: left;
                color: #127be4;
                margin-left: 2vw;
            }
        }
    }
</style>